import { PropType } from 'vue'

export const propsDefault = {
    testId: {
        // eslint-disable-next-line
        type: String as PropType<PropsDefault<any>['testId']>,
    },
}
